var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pax-icon-list__container"},[_vm._l((_vm.paxIconNamesNew),function(iconName){return [_c('img',{attrs:{"height":"24px","width":"24px","src":require(`../svgs/${iconName}.svg`),"alt":iconName}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }